import React, { useState } from 'react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ServicesBreakdown = ({ data = [], loading = false }) => {
  const [chartType, setChartType] = useState('bar'); // 'pie' or 'bar'

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  if (loading) {
    return (
      <div className="card-blue">
        <div className="card-header">
          <div style={{ height: '24px', width: '180px', background: 'var(--color-neutral-200)', borderRadius: 'var(--radius-md)' }} className="animate-pulse" />
        </div>
        <div className="card-body">
          <div style={{ height: '256px', background: 'var(--color-neutral-100)', borderRadius: 'var(--radius-md)' }} className="animate-pulse" />
        </div>
      </div>
    );
  }

  const chartData = data.map(service => ({
    name: service.name,
    revenue: service.revenue,
    color: service.color,
    emoji: service.emoji
  }));

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: 'var(--tooltip-bg)',
          padding: 'var(--space-3) var(--space-4)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-lg)',
          border: '1px solid var(--tooltip-border)'
        }}>
          <p style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 'var(--font-semibold)',
            color: 'var(--color-neutral-900)',
            marginBottom: 'var(--space-1)'
          }}>{payload[0].payload.name}</p>
          <p style={{
            fontSize: 'var(--text-sm)',
            color: 'var(--color-blue-600)',
            fontWeight: 'var(--font-medium)'
          }}>Omzet: {formatCurrency(payload[0].value)}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card-blue">
      <div className="card-header">
        <h3 className="card-title">Diensten Breakdown</h3>
        <div className="toggle-group-blue">
          <button
            onClick={() => setChartType('bar')}
            className={`toggle-btn ${chartType === 'bar' ? 'active' : ''}`}
          >
            Staaf
          </button>
          <button
            onClick={() => setChartType('pie')}
            className={`toggle-btn ${chartType === 'pie' ? 'active' : ''}`}
          >
            Cirkel
          </button>
        </div>
      </div>

      <div className="card-body">
        <div style={{ height: '256px' }}>
          <ResponsiveContainer width="100%" height="100%">
            {chartType === 'pie' ? (
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="revenue"
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            ) : (
              <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--color-neutral-200)" />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 12, fill: 'var(--color-neutral-600)' }}
                  angle={-45}
                  textAnchor="end"
                  height={80}
                  axisLine={{ stroke: 'var(--color-neutral-300)' }}
                />
                <YAxis
                  tickFormatter={formatCurrency}
                  tick={{ fontSize: 12, fill: 'var(--color-neutral-600)' }}
                  axisLine={{ stroke: 'var(--color-neutral-300)' }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="revenue" name="Omzet" radius={[4, 4, 0, 0]}>
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Bar>
              </BarChart>
            )}
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default ServicesBreakdown;
